export function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-inner">
        <a href="/" className="legal-back">← Back to Home</a>
        <h1>Terms of Service</h1>
        <p className="legal-updated">Last updated: April 2026</p>

        <h2>1. Acceptance</h2>
        <p>
          By accessing <strong>banoffee.work</strong> ("Site"), you agree to these terms. If you do not agree,
          please do not use the Site. These terms apply to all visitors, users, and clients.
        </p>

        <h2>2. Services</h2>
        <p>
          Banoffee provides AI automation consulting and development services. The Site serves as
          an informational and lead-generation platform. Actual service delivery is governed by
          individual client agreements (MSA/SOW).
        </p>

        <h2>3. Intellectual Property</h2>
        <ul>
          <li>All Site content (text, design, code, graphics) is owned by Banoffee unless otherwise noted.</li>
          <li>You may not reproduce, distribute, or create derivative works from Site content without written permission.</li>
          <li>Client project IP ownership is defined in individual service agreements.</li>
        </ul>

        <h2>4. User Conduct</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Site for unlawful purposes</li>
          <li>Attempt to gain unauthorised access to any part of the Site</li>
          <li>Submit false or misleading information through forms</li>
          <li>Scrape, crawl, or harvest data from the Site without permission</li>
          <li>Interfere with the Site's infrastructure or security</li>
        </ul>

        <h2>5. Disclaimer of Warranties</h2>
        <p>
          The Site is provided "as is" without warranties of any kind, express or implied. We do not guarantee
          that the Site will be error-free, uninterrupted, or free from harmful components.
        </p>
        <p>
          <strong>AI Disclaimer:</strong> Information about AI capabilities, ROI estimates, and automation
          outcomes presented on this Site are illustrative. Actual results vary based on your specific
          workflows, data quality, and implementation scope.
        </p>

        <h2>6. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Banoffee shall not be liable for any indirect,
          incidental, special, consequential, or punitive damages arising from your use of the Site,
          including but not limited to loss of profits, data, or business opportunities.
        </p>
        <p>
          Our total liability for any claim related to the Site shall not exceed ₹10,000 (INR) or
          the equivalent in your local currency.
        </p>

        <h2>7. Third-Party Links & Services</h2>
        <p>
          The Site may contain links to third-party services (Calendly, etc.). We are not responsible
          for the content, privacy practices, or availability of external sites. Use at your own risk.
        </p>

        <h2>8. Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless Banoffee, its founders, and team members from any
          claims, damages, or expenses arising from your violation of these terms or misuse of the Site.
        </p>

        <h2>9. Modifications</h2>
        <p>
          We reserve the right to modify these terms at any time. Continued use of the Site after
          changes constitutes acceptance. Material changes will be reflected in the "Last updated" date.
        </p>

        <h2>10. Governing Law</h2>
        <p>
          These terms are governed by the laws of India. Any disputes shall be subject to the
          exclusive jurisdiction of the courts in New Delhi, India.
        </p>

        <h2>11. Severability</h2>
        <p>
          If any provision of these terms is found unenforceable, the remaining provisions shall
          continue in full force and effect.
        </p>

        <h2>12. Contact</h2>
        <p>
          Questions about these terms? Email <a href="mailto:hello@banoffee.work">hello@banoffee.work</a>
        </p>
      </div>
    </div>
  )
}
